export const permissionsKeys = {
  page: 'content-management.pqrsd',
  pageBlockFind: 'content-management.pqrsd.procedures.find',
  pageBlockCreate: 'content-management.pqrsd.procedures.create',
  pageBlockUpdate: 'content-management.pqrsd.procedures.update',
  pageBlockRemove: 'content-management.pqrsd.procedures.remove',
  pageBlockUpdatePublish: 'content-management.pqrsd.publish.procedures.update',
  pageBlockUpdateStatusToDraft: 'content-management.pqrsd.procedures.updateStatusToDraft',
  pageBlockUpdateInactivate: 'content-management.pqrsd.inactivate.procedures.update',
} as const;
